.Panel {
  border: 2px solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  padding: 0.5rem;
  outline: none;
  transition:
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}

.Focused {
  border-color: var(--bs-primary);
  box-shadow: 0 0 0 0.2rem rgba(var(--bs-primary-rgb), 0.25);
}

.Calendar {
  flex: 1 1 auto;
  min-width: 0;

  /* events can only be resized from the bottom edge, to change the end time */
  :global(.rbc-addons-dnd-resize-ns-anchor:first-child) {
    display: none;
  }
}

.Sidebar {
  width: 400px;
  flex-shrink: 0;

  :global(label) {
    font-size: 0.75rem;
  }
}

.SelectedEvent {
  outline: 3px solid var(--bs-warning);
  outline-offset: 1px;
  z-index: 2;
}

.UnsavedEvent {
  border: 2px dashed #ffffff !important;
}
